export enum LockStage {
  WITHDRAW,
  UPDATE_BRIBES,
  UPDATE_BOUNTY,
  DELETE,
  ERASE_DEBT,
  ERASE_DEBT2,
  CONFIRM_ERASE_DEBT,
  CONFIRM_ERASE_DEBT2,
  CONFIRM_LOCK_TOKENS,
  CONFIRM_WITHDRAW,
  CONFIRM_UPDATE_BRIBES,
  CONFIRM_UPDATE_BOUNTY,
  CONFIRM_DELETE,
  CONFIRM_UPDATE_GAUGE,
  CONFIRM_DISTRIBUTE,
  CONFIRM_ADMIN_WITHDRAW,
  SETTINGS,
  ADMIN_SETTINGS,
  TX_CONFIRMED,
}
